import { memo } from 'react';
import { ChakraProvider, SystemContext } from '@chakra-ui/react';

import {
  ColorModeProvider,
  ColorModeProviderProps,
} from './components/colorMode';
import { Toaster } from './components/Toaster';

type DesignSystemProviderProps = ColorModeProviderProps & {
  theme: SystemContext;
};

const DesignSystemProviderComponent = ({
  theme,
  children,
  ...props
}: DesignSystemProviderProps) => (
  <ChakraProvider value={theme}>
    <ColorModeProvider {...props} defaultTheme="light" enableSystem={false}>
      {children}
      <Toaster />
    </ColorModeProvider>
  </ChakraProvider>
);

export const DesignSystemProvider = memo(DesignSystemProviderComponent);
